import { render, staticRenderFns } from "./CalendariosPantalla.vue?vue&type=template&id=ebe771ac&"
import script from "./CalendariosPantalla.vue?vue&type=script&lang=ts&"
export * from "./CalendariosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ebe771ac', component.options)
    } else {
      api.reload('ebe771ac', component.options)
    }
    module.hot.accept("./CalendariosPantalla.vue?vue&type=template&id=ebe771ac&", function () {
      api.rerender('ebe771ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Calendarios/CalendariosPantalla.vue"
export default component.exports